import { render, staticRenderFns } from "./UserPlanningBlock.vue?vue&type=template&id=4077abf2"
import script from "./UserPlanningBlock.vue?vue&type=script&lang=js"
export * from "./UserPlanningBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports